import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isFunction from "lodash/isFunction";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Paper, Button, Input, Form, BorrowerFiles, // BorrowerDocuments,
useUser } from 'components';
import { showApiError } from 'utils';
import { CREDIT_STATUS, creditDocumentsTypeName, CREDIT_PAYMENT_TYPE, ROLES, dateFormat } from 'enums';
import { changeCreditStatus, getDocumentTypesForCredit, geSignetDocumentForCredit } from 'services';
import { infoBox, infoBoxRed } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var draft = CREDIT_STATUS.draft,
    awaiting_approval = CREDIT_STATUS.awaiting_approval,
    approved = CREDIT_STATUS.approved,
    active = CREDIT_STATUS.active,
    delayed = CREDIT_STATUS.delayed;

var CreditDocumentsTab = function CreditDocumentsTab(_ref) {
  var _data$home_visit_fee_, _data$borrower, _Object$entries;

  var creditId = _ref.creditId,
      data = _ref.data,
      onCreditStatusChange = _ref.onCreditStatusChange;

  var _useUser = useUser(),
      userInfo = _useUser.userInfo;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      documentTypes = _useState2[0],
      setDocumentTypes = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      canPayCredit = _useState4[0],
      setCanPayCredit = _useState4[1];

  var creditStatus = data === null || data === void 0 ? void 0 : data.status;
  var isPartnerOrPartnerManager = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_role) === ROLES.partner || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_role) === ROLES.partner_manager;
  var isSeparatePaymentWithHomeVisit = (data === null || data === void 0 ? void 0 : data.credit_payment_type) === CREDIT_PAYMENT_TYPE.home_visit_fee_separate_payment && (data === null || data === void 0 ? void 0 : (_data$home_visit_fee_ = data.home_visit_fee_payment_plan) === null || _data$home_visit_fee_ === void 0 ? void 0 : _data$home_visit_fee_.length) > 0;
  var canIssueAbsenceProtocol = isPartnerOrPartnerManager && isSeparatePaymentWithHomeVisit && [active, delayed].includes(creditStatus);
  var borrowerIdNumber = data === null || data === void 0 ? void 0 : (_data$borrower = data.borrower) === null || _data$borrower === void 0 ? void 0 : _data$borrower.id_number; // const documents = data?.borrower?.id_card_images;

  useEffect(function () {
    fetchDocumentTypes();
  }, []);
  useEffect(function () {
    if (!documentTypes || !creditStatus) return;
    var isApproved = creditStatus === approved;
    var allRequiredDocsSigned = Object.entries(documentTypes).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          docType = _ref3[0];

      return docType !== 'documents_before_activation';
    }).every(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          signatures = _ref5[1];

      return Object.values(signatures).every(function (signed) {
        return signed === true;
      });
    });
    var isPartnerWithSeparatePayment = (data === null || data === void 0 ? void 0 : data.credit_payment_type) === CREDIT_PAYMENT_TYPE.home_visit_fee_separate_payment && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_role) === ROLES.partner;
    setCanPayCredit(isApproved && allRequiredDocsSigned && !isPartnerWithSeparatePayment);
  }, [documentTypes, creditStatus, data === null || data === void 0 ? void 0 : data.credit_payment_type, userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_role]);

  var fetchDocumentTypes = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getDocumentTyp, _yield$getDocumentTyp2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getDocumentTypesForCredit(creditId);

            case 2:
              _yield$getDocumentTyp = _context.sent;
              _yield$getDocumentTyp2 = _slicedToArray(_yield$getDocumentTyp, 2);
              res = _yield$getDocumentTyp2[0];
              err = _yield$getDocumentTyp2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setDocumentTypes(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchDocumentTypes() {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleRejectApprove = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(status, description) {
      var _yield$changeCreditSt, _yield$changeCreditSt2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return changeCreditStatus(creditId, _objectSpread({
                status: status
              }, description && {
                description: description
              }));

            case 2:
              _yield$changeCreditSt = _context2.sent;
              _yield$changeCreditSt2 = _slicedToArray(_yield$changeCreditSt, 2);
              res = _yield$changeCreditSt2[0];
              err = _yield$changeCreditSt2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 8:
              _isFunction(onCreditStatusChange) && onCreditStatusChange(res);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleRejectApprove(_x, _x2) {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleOpenPdf = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type, documentId) {
      var _yield$geSignetDocume, _yield$geSignetDocume2, res, err, url;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return geSignetDocumentForCredit(creditId, {
                type: type,
                document_id: documentId
              });

            case 2:
              _yield$geSignetDocume = _context3.sent;
              _yield$geSignetDocume2 = _slicedToArray(_yield$geSignetDocume, 2);
              res = _yield$geSignetDocume2[0];
              err = _yield$geSignetDocume2[1];

              if (!err) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 8:
              url = URL.createObjectURL(new File([res], 'filename.json', {
                type: 'application/pdf'
              }));
              window.open(url, '_blank');

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleOpenPdf(_x3, _x4) {
      return _ref8.apply(this, arguments);
    };
  }();

  var absenceProtocols = (data === null || data === void 0 ? void 0 : data.absence_refusal_protocols) || [];
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref9) {
      var css = _ref9.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0437\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430"), ___EmotionJSX(Row, {
        horizontalGap: 8
      }, (data === null || data === void 0 ? void 0 : data.status) === approved && canPayCredit && ___EmotionJSX(Col, {
        md: "auto"
      }, ___EmotionJSX(Button, {
        type: "success",
        linkTo: {
          pathname: "/credits/pay/".concat(creditId),
          state: {
            credit: data
          }
        }
      }, "\u0418\u0437\u043F\u043B\u0430\u0442\u0438 \u043A\u0440\u0435\u0434\u0438\u0442")), [draft, approved, awaiting_approval].indexOf(data === null || data === void 0 ? void 0 : data.status) !== -1 && !canPayCredit && ___EmotionJSX(Col, {
        md: "auto"
      }, ___EmotionJSX(Button, {
        type: "warning",
        linkTo: {
          pathname: "/credits/sign/".concat(creditId),
          state: {
            credit: data
          }
        }
      }, "\u041F\u043E\u0434\u043F\u0438\u0441\u0432\u0430\u043D\u0435 \u043D\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438")), canIssueAbsenceProtocol && ___EmotionJSX(Col, {
        md: "auto"
      }, ___EmotionJSX(Button, {
        type: "info",
        linkTo: {
          pathname: "/credits/absence-protocol/".concat(creditId),
          state: {
            credit: data
          }
        }
      }, "\u041F\u0420\u041E\u0422\u041E\u041A\u041E\u041B \u0437\u0430 \u043A\u043E\u043D\u0441\u0442\u0430\u0442\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043E\u0442\u0441\u044A\u0441\u0442\u0432\u0438\u0435"))));
    },
    margin: "0 0 2em 0"
  }, creditStatus === awaiting_approval && ___EmotionJSX(React.Fragment, null, !!(userInfo !== null && userInfo !== void 0 && userInfo.can_approve) && ___EmotionJSX("div", {
    css: infoBox
  }, ___EmotionJSX("p", null, "\u0417\u0430 \u0434\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0438\u0442\u0435 \u043A\u0440\u0435\u0434\u0438\u0442\u0430, \u043C\u043E\u043B\u044F \u043A\u043B\u0438\u043A\u0435\u043D\u0435\u0442\u0435 \u0431\u0443\u0442\u043E\u043D\u0430 \u201D\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438\u201D."), ___EmotionJSX(Row, {
    horizontalGap: 8
  }, ___EmotionJSX(Col, {
    md: "auto"
  }, ___EmotionJSX(Button, {
    type: "success",
    onClick: function onClick() {
      return handleRejectApprove('approved');
    }
  }, "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438"))))), (creditStatus === awaiting_approval || creditStatus === approved) && ___EmotionJSX(React.Fragment, null, !!(userInfo !== null && userInfo !== void 0 && userInfo.can_approve) && ___EmotionJSX("div", {
    css: infoBox
  }, ___EmotionJSX("p", null, "\u0417\u0430 \u0434\u0430 \u043E\u0442\u0445\u0432\u044A\u0440\u043B\u0438\u0442\u0435 \u043A\u0440\u0435\u0434\u0438\u0442\u0430, \u043C\u043E\u043B\u044F \u043E\u0441\u0442\u0430\u0432\u0435\u0442\u0435 \u043A\u043E\u043C\u0435\u043D\u0442\u0430\u0440 \u0438 \u043A\u043B\u0438\u043A\u043D\u0435\u0442\u0435 \u0431\u0443\u0442\u043E\u043D\u0430 \u201D\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u0438\u201D."), ___EmotionJSX(Form, {
    onSubmit: function onSubmit(data) {
      var _data$values;

      return handleRejectApprove('rejected', data === null || data === void 0 ? void 0 : (_data$values = data.values) === null || _data$values === void 0 ? void 0 : _data$values.description);
    }
  }, ___EmotionJSX(Row, {
    horizontalGap: 8
  }, ___EmotionJSX(Col, {
    md: 12
  }, ___EmotionJSX(Input, {
    type: "textarea",
    formId: "description",
    label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    required: true
  })), ___EmotionJSX(Col, {
    md: "auto"
  }, function (_ref10) {
    var onSubmit = _ref10.onSubmit;
    return ___EmotionJSX(Button, {
      type: "danger",
      onClick: onSubmit
    }, "\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u0438");
  }))))), !(userInfo !== null && userInfo !== void 0 && userInfo.can_approve) && [approved, awaiting_approval, draft].indexOf(creditStatus) !== -1 && ___EmotionJSX("div", {
    css: infoBoxRed
  }, ___EmotionJSX("p", null, "\u041D\u044F\u043C\u0430\u0442\u0435 \u043F\u0440\u0430\u0432\u0430 \u0434\u0430 \u043E\u0434\u043E\u0431\u0440\u0438\u0442\u0435 \u0438\u043B\u0438 \u043E\u0442\u0445\u0432\u044A\u0440\u043B\u0438\u0442\u0435 \u043A\u0440\u0435\u0434\u0438\u0442\u0430!")), documentTypes && ___EmotionJSX(Row, {
    horizontalGap: 8,
    verticalGap: 8
  }, Object === null || Object === void 0 ? void 0 : (_Object$entries = Object.entries(documentTypes)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(function (_ref11) {
    var _creditDocumentsTypeN;

    var _ref12 = _slicedToArray(_ref11, 2),
        label = _ref12[0],
        value = _ref12[1];

    var allSigned = Object.values(value).every(function (v) {
      return v === true;
    });
    return allSigned && ___EmotionJSX(Col, {
      md: "auto",
      key: label
    }, ___EmotionJSX(Button, {
      onClick: function onClick() {
        return handleOpenPdf(label);
      }
    }, (_creditDocumentsTypeN = creditDocumentsTypeName[label]) !== null && _creditDocumentsTypeN !== void 0 ? _creditDocumentsTypeN : label));
  })), absenceProtocols.length > 0 && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h6", {
    style: {
      marginTop: '1.5em',
      marginBottom: '0.5em'
    }
  }, "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0438 \u0437\u0430 \u043E\u0442\u0441\u044A\u0441\u0442\u0432\u0438\u0435/\u043E\u0442\u043A\u0430\u0437:"), ___EmotionJSX(Row, {
    horizontalGap: 8,
    verticalGap: 8
  }, absenceProtocols.map(function (protocol, index) {
    return ___EmotionJSX(Col, {
      md: "auto",
      key: protocol.id || index
    }, ___EmotionJSX(Button, {
      type: "secondary",
      onClick: function onClick() {
        return handleOpenPdf('protocol_absence_refusal_payment', protocol.id);
      }
    }, "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B #", index + 1, " - ", moment(protocol.created_at).format(dateFormat)));
  }))))), borrowerIdNumber && ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0437\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B",
    margin: "0 0 2em 0"
  }, ___EmotionJSX(BorrowerFiles, {
    borrowerIdNumber: borrowerIdNumber,
    getDocuments: true
  })))));
};

CreditDocumentsTab.propTypes = {
  data: PropTypes.object,
  creditId: PropTypes.number,
  onCreditStatusChange: PropTypes.func
};
export default CreditDocumentsTab;